import Index from "..";
import { MODEL } from "./consts";
import { MODULE } from "../../consts";

export const AccountMoveLineRoutes = [
  { path: `/${MODULE}/${MODEL}`, exact: true, component: Index },
];

export default AccountMoveLineRoutes;
